interface IconProps {
  color?: string
}

export const Monitor = ({ color }: IconProps) => {
  return (
    <svg
      aria-hidden="true"
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.1333 8.00013C3.1333 6.04872 4.71523 4.4668 6.66663 4.4668H25.3333C27.2847 4.4668 28.8666 6.04872 28.8666 8.00013V20.0001C28.8666 21.9515 27.2847 23.5335 25.3333 23.5335H6.66663C4.71523 23.5335 3.1333 21.9515 3.1333 20.0001V8.00013ZM6.66663 6.20013C5.67252 6.20013 4.86663 7.00602 4.86663 8.00013V20.0001C4.86663 20.9942 5.67252 21.8001 6.66663 21.8001H25.3333C26.3274 21.8001 27.1333 20.9942 27.1333 20.0001V8.00013C27.1333 7.00602 26.3274 6.20013 25.3333 6.20013H6.66663Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8 26.6668C11.8 26.1881 12.188 25.8001 12.6666 25.8001H19.3333C19.8119 25.8001 20.2 26.1881 20.2 26.6668C20.2 27.1454 19.8119 27.5335 19.3333 27.5335H12.6666C12.188 27.5335 11.8 27.1454 11.8 26.6668Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
